// Polyfills for Node.js globals in browser environment
import { Buffer } from 'buffer';
import process from 'process/browser.js';
import { EventEmitter } from 'events';
import * as util from 'util';

// Set globals that are expected by Node.js packages
window.Buffer = Buffer;
window.process = process;
window.global = window;

// Make Buffer available globally (required by many crypto packages)
window.Buffer = Buffer;
window.process = process;
window.global = window;

// Export for explicit imports
export { Buffer, process, EventEmitter, util };
